<template>    
    <div class="container-fluid" id="dvcrud">
        <div class="row">
            <consultaprodutos v-bind:idtabela="vidtabela" v-bind:showprtabela="vshowprtabela" v-bind:filtrotipo="tipopropesquisa"></consultaprodutos>
            <div class="col-md-12">
                <breadcrumb v-bind:bcitens="itensbc" v-bind:mtdcancelar="mtdcancelaredicao"></breadcrumb>
            </div>
            <div class="col-md-12">
                <div id="pnlista" class="card" style="display: none;">
                    <div class="card-header"><span id="titlista">LISTAGEM DE {{ itensbc.item1.titulo }}</span>
                        <router-link to="/">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        </router-link>						
                    </div>
                    <div class="card-body" style="padding: 10px;">
                        <div class="row">
                            <div class="col-sm-4 col-md-2 col-lg-2">
                                <label for="cbopfiltro">Filtrar:</label>
                                <select name="cbopfiltro" class="form-control form-control-sm" id="cbopfiltro" v-model="pfiltro" @change="mtdlimpar_listagem()">
                                    <option value="0">Código</option>
                                    <option value="1">Descrição</option>
                                </select>
                            </div>
                            <div class="col-sm-9 col-md-7 col-lg-6">
                                <label for="edconteudopesq">Conteúdo da pesquisa:</label>
                                <input id="edconteudopesq" type="text" class="form-control form-control-sm" v-model="pconteudo" @keyup="mtdlimpar_listagem()">
                            </div>
							<div class="col-sm-12 col-md-4 col-lg-4">
								<span class="lblselect2">Filial:</span>
								<select id="cbfilialpesq" data-placeholder="Selecione uma filial" v-model="pidfilial" data-allow-clear="true" style="width:100%;">
								</select>
							</div>                            
							<div class="col-sm-12 col-md-2 col-lg-1">
								<label for="cbfiltroperiodo">Período:</label>
								<select class="form-control form-control-sm" id="cbfiltroperiodo" v-model="pfiltroperiodo" v-bind="selecionaperiodo">
									<option value="0">Não</option>
									<option value="1">Sim</option>
								</select>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtini">De:</label>
								<div class="input-group">
									<date-picker id="eddtini" v-model="pdtini" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>								
								</div>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtfim">até:</label>
								<div class="input-group">
									<date-picker id="eddtfim" v-model="pdtfim" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>																			
								</div>
							</div>                            
                            <div class="col-sm-4 col-md-2 col-lg-2">
                                <label for="cbsituacaopesq">Situação:</label>
                                <select name="cbsituacaopesq" class="form-control form-control-sm" id="cbsituacaopesq" v-model="psituacao" @change="mtdlimpar_listagem()">
                                    <option value="0">Aberta</option>
                                    <option value="1">Finalizada</option>
                                    <option value="2">Todas</option>
                                </select>
                            </div>                            
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbqtdreg">Registros:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistros" @change="mtdlimpar_listagem()">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i> Listar</button>
                            </div>
                            <div class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table ref="reflstordensproducao"
                                        :rows="lstordensproducao"
                                        :columns="columns"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="id_f" slot-scope="item">
                                        {{ item.row.id }}
                                    </template>
                                    <template slot="slot_situacao" slot-scope="item">
                                        <span v-if="parseInt(item.row.situacao) === 0" class="badge badge-pill badge-primary" style="background: #646dd4;">Em edição</span>
                                        <span v-else class="badge badge-pill badge-primary" style="background: #5a956a;">Finalizada</span>                                        
                                    </template>
                                    <template slot="slot_totalcusto" slot-scope="item">
                                        <span style="font-weight: 600;">{{ mtdformatavalordecimal(item.row.totalcusto, 2) }}</span>
                                    </template>                                                                        
                                    <template slot="opcoes" slot-scope="item">
										<button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdmostrarmenu(item.row)" style="width: 35px;">
											<i class="fa fa-navicon"></i>
										</button>                                        
                                    </template>
                                </vue-bootstrap4-table>
                            </div>
                            <div class="col-md-12">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                        Registros
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{lstordensproducao.length}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <div class="col-6 col-sm-6 col-md-8 col-lg-8" id="dvpaginacao">
                                <v-pagination
                                        v-model="pagina_atual"
                                        :page-count="pqtd_paginas"
                                        :classes="bootstrapPaginationClasses">
                                </v-pagination>
                            </div>
                            <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                            </div>                            
                            <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-success btn-sm btn-block btn_ajusta_top" @click.prevent="mtdnovo()"><i class="fa fa-file"></i> Novo</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="pncadastro" class="card" style="display:none;">
                    <div class="card-header"><span>{{itensbc.item2.titulo}}</span>                        
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edid">Código:</label>
                                <input type="text" class="form-control form-control-sm" id="edid" v-model="vid"
                                       maxlength="20" disabled/>
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-3">
                                <label for="eddescricao">*Descrição:</label>
                                <input type="text" v-model="vdescricao" v-bind:disabled="ativadesativa" class="form-control form-control-sm" id="eddescricao" maxlength="50">
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <span class="lblselect2">*Filial:</span>
                                <select id="cbfilial" data-placeholder="Selecione a filial" v-bind:disabled="ativadesativa" v-model="videstoque" data-allow-clear="true" style="width:100%;">
                                </select>
                            </div> 
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtinicio">*Dt. Inicio:</label>
								<div class="input-group">
									<date-picker id="eddtinicio" v-model="vdtinicio" :config="options"
										class="form-control form-control-sm" v-bind:disabled="ativadesativa"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>										
								</div>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddttermino">*Dt. termino:</label>
								<div class="input-group">
									<date-picker id="eddttermino" v-model="vdttermino" :config="options"
										class="form-control form-control-sm" v-bind:disabled="ativadesativa"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>										
								</div>
							</div>                                                        
                            <div class="col-md-12" style="margin-top: 15px;">
                                <div class="card">
                                    <div class="card-header card-in text-center" style="padding: 5px;">PRODUTO A SER PRODUZIDO</div>
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-sm-12 col-md-3 col-lg-2">
                                                <label for="edidprodutoprod">Produto:</label>
                                                <div class="input-group" style="z-index: 1;">
                                                    <input type="text" class="form-control form-control-sm" id="edidprodutoprod" v-model="vcoddigprod" maxlength="20" v-on:blur="mtdlocalizarproduto(vcoddigprod, 1)" v-on:keyup.13="mtdlocalizarproduto(vcoddigprod, 1)" style="text-transform: uppercase;" v-bind:disabled="ativadesativa">
                                                    <div class="input-group-append">
                                                        <a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="mtdconsultarproduto(1)" v-bind:disabled="ativadesativa"><i class="fa fa-search" style="padding-top: 3px;"></i></a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-12 col-md-6 col-lg-5">
                                                <label for="eddescricaoprodutoprod">Descrição do produto:</label>
                                                <input type="text" class="form-control form-control-sm" id="eddescricaoprodutoprod" v-model="vdescricaoprodutoprod" maxlength="100" style="font-weight: bold;" disabled>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edqtditemprod">Quantidade:</label>
                                                <money type="text" class="form-control form-control-sm" id="edqtditemprod" v-model="vqtditemprod" data-bv-group=".group" maxlength="20" style="text-align:right;" v-bind:disabled="ativadesativa"></money>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <span class="lblselect2">Estoque:</span>
                                                <select id="cbestoqueprod" data-placeholder="Selecione o estoque" v-model="videstoqueprod" data-allow-clear="true" style="width:100%;" v-bind:disabled="ativadesativa">
                                                </select>
                                            </div>
                                            <div class="col-md-1">
                                                <button type="button" class="btn btn-info btn-sm btn-block" @click.prevent="mtdobterformula()" style="margin-top: 20px;" title="Importar fórmula"><i class="fa fa-mail-reply"></i></button>
                                            </div>                                                                                        
                                        </div>
                                    </div>
                                </div>        
                            </div>                                                   
                            <div class="col-md-12" style="margin-top: 15px;">
                                <div class="card">
                                    <div class="card-header card-in text-center" style="padding: 5px;">INSUMOS</div>
                                    <div class="card-body">
                                        <div v-show="parseInt(opcrud) < 3" class="row">
                                            <div class="col-sm-12 col-md-3 col-lg-2">
                                                <label for="edidproduto">Produto:</label>
                                                <div class="input-group" style="z-index: 1;">
                                                    <input type="text" class="form-control form-control-sm" id="edidproduto" v-model="vcoddig" maxlength="20" v-on:blur="mtdlocalizarproduto(vcoddig, 2)" v-on:keyup.13="mtdlocalizarproduto(vcoddig, 2)" style="text-transform: uppercase;">
                                                    <div class="input-group-append">
                                                        <a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="mtdconsultarproduto(2)"><i class="fa fa-search" style="padding-top: 3px;"></i></a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-12 col-md-5 col-lg-4">
                                                <label for="eddescricaoproduto">Descrição do produto:</label>
                                                <input type="text" class="form-control form-control-sm" id="eddescricaoproduto" v-model="vdescricaoproduto" maxlength="100" style="font-weight: bold;" disabled>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edqtditem">Quantidade:</label>
                                                <money type="text" class="form-control form-control-sm" id="edqtditem" v-model="vqtditem" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <span class="lblselect2">Estoque:</span>
                                                <select id="cbestoque" data-placeholder="Selecione o estoque" v-model="videstoque" data-allow-clear="true" style="width:100%;">
                                                </select>
                                            </div>                                            
                                            <div class="col-md-2">
                                                <button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdincluiritem()" style="margin-top: 20px;"><i class="fa fa-plus"></i> Incluir</button>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-12" style="margin-top: 10px;">
                                                <vue-bootstrap4-table ref="reflstitens"
                                                        :rows="lstitens"
                                                        :columns="columnsitens"
                                                        :config="configitens"
                                                        :classes="classes">
                                                    <template slot="empty-results">
                                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                                    </template>
                                                    <!-- ícones de ordenação da table -->
                                                    <template slot="sort-asc-icon">
                                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                                    </template>
                                                    <template slot="sort-desc-icon">
                                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                                    </template>
                                                    <template slot="no-sort-icon">
                                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                                    </template>                                    
                                                    <!--  -->                                                    
                                                    <template slot="opcoes" slot-scope="item">
                                                        <button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcluiritem(item.row)" v-bind:disabled="parseInt(opcrud) === 3"><i class="fa fa-trash"></i></button>
                                                    </template>
                                                    <template slot="slot_codigo" slot-scope="item">
                                                        <span style="font-weight: 600;">{{ item.row.coddig }}</span>
                                                    </template>
                                                    <template slot="slot_prcusto" slot-scope="item">
                                                        <span>{{ mtdformatavalordecimal(item.row.prcusto, 2) }}</span>
                                                    </template>                                                    
                                                    <template slot="slot_qtditem" slot-scope="item">
                                                        <span @click.prevent="mtdalterarqtd(item.row, false, 1)"><i class="op-qtd op-qtd-ret fa fa-minus-circle"></i></span>
                                                        <span style="font-weight: 600;">{{ item.row.qtditem }}</span>
                                                        <span @click.prevent="mtdalterarqtd(item.row, true, 1)"><i class="op-qtd op-qtd-acres fa fa-plus-circle"></i></span>
                                                    </template>
                                                    <template slot="slot_totalcusto" slot-scope="item">
                                                        <span style="font-weight: 600;">{{ mtdformatavalordecimal(item.row.totalcusto, 2) }}</span>
                                                    </template>                                                    
                                                </vue-bootstrap4-table>
                                            </div>                                                                                        
                                        </div>
                                        <div class="row">
                                            <div class="col-md-12">
                                                <ul class="list-group">
                                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                                        <strong>Total do custo</strong>
                                                        <span class="badge badge-danger badge-pill text-right bdg-qtd-reg-info">{{mtdformatavalordecimal(vtotalcusto, 2)}}</span>
                                                    </li>
                                                </ul>
                                            </div>                                            
                                        </div>
                                    </div>
                                </div>        
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-sm-8">
                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>Campos com asterisco(*) devem ser informados</strong>.</h5>
                            </div>
                            <div class="col-sm-2">
                                <button id="btgravar" v-if="(opcrud == 1)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Gravar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 2)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Alterar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 3)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Excluir
                                </button>
                            </div>
                            <div class="col-sm-2">
                                <button type="button" @click.prevent="mtdcancelaredicao()" class="btn btn-secondary btn-sm" style="width:100%">
                                    <i class="fa fa-close"></i> Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal para efetivação da ordem de produção -->
        <div class="modal fade" id="mdlefetivacao" tabindex="-1" role="dialog" aria-labelledby="mdlefetivacaotitulo" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 v-if="efetivacao" class="modal-title"><i class="fa fa-check"></i> Efetivação da ordem de produção</h5>
                    <h5 v-else class="modal-title"><i class="fa fa-check"></i> Detalhes da ordem de produção</h5>        
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                <div class="row">
                        <div class="col-md-12 text-center">
                            <div class="alert alert-primary" style="padding: 5px;" role="alert">
                                <span style="color: #666666; font-weight: 600;"><strong>{{eid}}</strong> - {{edescricao}}</span>
                                <template v-if="!efetivacao">
                                    <span v-if="parseInt(esituacao) === 0" class="badge badge-pill badge-primary" style="background: #646dd4; float: right; font-size: 12px;">Em edição</span>
                                    <span v-else class="badge badge-pill badge-primary" style="background: #5a956a; float: right;  font-size: 12px;">Finalizada</span>                                        
                                </template>
                            </div>                                                                
                        </div>    
                        <div class="col-md-12">
                            <div class="alert alert-secondary" style="background-color: #ffffff; padding: 10px;" role="alert">
                                <div class="row">
                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                        <label for="edidproperda">Código:</label>
                                        <input type="text" class="form-control form-control-sm" id="edidproperda" v-bind:value="ecoddig"
                                            maxlength="20" disabled/>
                                    </div>
                                    <div class="col-sm-12 col-md-4 col-lg-4">
                                        <label for="eddescricaoproperda">Descrição:</label>
                                        <input type="text" v-bind:value="edescproduto" class="form-control form-control-sm" id="eddescricaoproperda" maxlength="50" disabled>
                                    </div>
                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                        <label for="edestoqueproperda">Estoque:</label>
                                        <input type="text" v-bind:value="edescestoque" class="form-control form-control-sm" id="edestoqueproperda" maxlength="50" disabled>
                                    </div>                                
                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                        <label for="edqtdprevista">Qtd. Prevista:</label>
                                        <money type="text" class="form-control form-control-sm" id="edqtdprevista" v-model="eqtditemprevista" data-bv-group=".group" maxlength="20" style="text-align:right;" disabled></money>
                                     </div>                                
                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                        <label for="edqtdproperda">Qtd. Produzida:</label>
                                        <money type="text" class="form-control form-control-sm" id="edqtdproperda" v-model="eqtditem" data-bv-group=".group" maxlength="20" style="text-align:right;" v-bind:disabled="!efetivacao"></money>
                                    </div>                                                                
                                </div>
                            </div>                                                                
                        </div>  
                        <div class="col-md-12">
                            <ul class="nav nav-tabs">
                                <li class="nav-item">
                                    <a class="nav-link active" data-toggle="tab" href="#dvinsumos">Insumos</a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" data-toggle="tab" href="#dvperdas">Perdas</a>
                                </li>
                            </ul>
                            <div class="tab-content border-left border-right border-bottom" style="margin-bottom: 15px;">
                                <div class="tab-pane container active" id="dvinsumos" style="padding-top: 15px;">
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="table-responsive">
                                                <table class="table table-bordered table-sm table-hover">
                                                    <thead class="thead-light">
                                                        <tr style="font-weight: 600;">
                                                            <th>Item:</th>
                                                            <th>Código:</th>
                                                            <th>Descrição:</th> 
                                                            <th>Pr. Custo:</th>
                                                            <th>Qtd:</th>                                        
                                                            <th>Total custo:</th>
                                                            <th>Estoque:</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(item, index) in elstitens" v-bind:key="index">
                                                            <td style="font-weight: 600; width: 50px;">{{ item.item }}</td>
                                                            <td style="font-weight: 600;">{{ item.coddig }}</td>
                                                            <td>{{ item.descproduto }}</td>
                                                            <td style="text-align: right;">
                                                                {{mtdformatavalordecimal(parseFloat(item.prcusto), 2)}}
                                                            </td>                                        
                                                            <td style="text-align: right; font-weight: 600;">
                                                                {{mtdformatavalordecimal(parseFloat(item.qtditem), 3)}}
                                                            </td>
                                                            <td style="text-align: right; font-weight: 600;">
                                                                <span class="text-danger">{{mtdformatavalordecimal(parseFloat(item.totalcusto), 2)}}</span>
                                                            </td>                                        
                                                            <td style="font-weight: 200;">{{ item.descestoque }}</td>       
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>      
                                        </div>
                                    </div>
                                </div>
                                <div class="tab-pane container fade" id="dvperdas" style="padding-top: 10px;">
                                    <div v-show="efetivacao" class="row">
                                        <div class="col-sm-12 col-md-5 col-lg-5">
                                            <span class="lblselect2">Produto:</span>
                                            <select id="cbprodutoperda" data-placeholder="Selecione o item" v-model="vidprodutoperda" data-allow-clear="true" style="width:100%;">
                                            </select>
                                        </div>                                    
                                        <div class="col-sm-12 col-md-2 col-lg-2">
                                            <label for="edqtditemperda">Quantidade:</label>
                                            <money type="text" class="form-control form-control-sm" id="edqtditemperda" v-model="vqtditemperda" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
                                        </div>
                                        <div class="col-sm-12 col-md-3 col-lg-3">
                                            <span class="lblselect2">Estoque:</span>
                                            <select id="cbestoqueperda" data-placeholder="Selecione o estoque" v-model="videstoqueperda" data-allow-clear="true" style="width:100%;">
                                            </select>
                                        </div> 
                                        <div class="col-md-2">
                                            <button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdincluiritemperda()" style="margin-top: 20px;"><i class="fa fa-plus"></i> Incluir</button>
                                        </div>
                                    </div>
                                    <div class="row" style="padding-top: 10px;">
                                        <div class="col-12">
                                            <div class="table-responsive">
                                                <table class="table table-bordered table-sm table-hover">
                                                    <thead class="thead-light">
                                                        <tr style="font-weight: 600;">
                                                            <th v-if="efetivacao" style="width: 50px;"></th>
                                                            <th>Item:</th>
                                                            <th>Código:</th>
                                                            <th>Descrição:</th> 
                                                            <th>Pr. Custo:</th>
                                                            <th>Qtd:</th>                                        
                                                            <th>Total custo:</th>
                                                            <th>Estoque:</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(item, index) in elstitensperdas" v-bind:key="index">
                                                            <td v-if="efetivacao">
                                                                <button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcluiritemperda(item)"><i class="fa fa-trash"></i></button>
                                                            </td>
                                                            <td style="font-weight: 600; width: 50px;">{{ item.item }}</td>
                                                            <td style="font-weight: 600;">{{ item.coddig }}</td>
                                                            <td>{{ item.descproduto }}</td>
                                                            <td style="text-align: right;">
                                                                {{mtdformatavalordecimal(parseFloat(item.prcusto), 2)}}
                                                            </td>                                        
                                                            <td style="text-align: right; font-weight: 600;">
                                                                {{mtdformatavalordecimal(parseFloat(item.qtditem), 3)}}
                                                            </td>
                                                            <td style="text-align: right; font-weight: 600;">
                                                                <span class="text-danger">{{mtdformatavalordecimal(parseFloat(item.totalcusto), 2)}}</span>
                                                            </td>                                        
                                                            <td style="font-weight: 200;">{{ item.descestoque }}</td>       
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>      
                                        </div>                                    
                                    </div>
                                </div>
                            </div>                  
                        </div>
                        <div class="col-md-12">
                            <ul class="list-group">
                                <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                    <span style="font-weight: 600;">Total custo</span>
                                    <span class="badge badge-danger badge-pill text-right bdg-qtd-reg-info">{{mtdformatavalordecimal(parseFloat(etotalcusto), 2)}}</span>
                                </li>
                            </ul>      
                        </div>              
                </div>
                </div>
                <div class="modal-footer">
                    <button v-show="efetivacao" type="button" class="btn btn-primary btn-sm" style="width: 120px;" @click.prevent="mtdconfirmaefetivacao()"><i class="fa fa-check"></i> Efetivar</button>                
                    <button v-if="efetivacao" type="button" class="btn btn-secondary btn-sm" style="width: 120px;" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>                
                    <button v-else type="button" class="btn btn-secondary btn-sm" style="width: 120px;" data-dismiss="modal"><i class="fa fa-close"></i> Sair</button>                
                </div>
                </div>
            </div>
        </div>
        <!-- Modal para seleção da fórmula -->
        <div class="modal fade" id="mdformula">
            <div class="modal-dialog modal-sm modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Selecione uma fórmula</h4>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>            
                <div class="modal-body">
                    <div class="row">
                        <div class="col-12">
                            <span class="lblselect2">Fórmula:</span>
                            <select id="cbformula" data-placeholder="Selecione o estoque" v-model="vidformulaimportar" data-allow-clear="true" style="width:100%;">
                            </select>
                        </div>
                        <div class="col-12">
                            <span class="lblselect2">Estoque:</span>
                            <select id="cbestoqueformula" data-placeholder="Selecione o estoque" v-model="videstoqueformula" data-allow-clear="true" style="width:100%;">
                            </select>
                        </div>                        
                        <div class="col-12">
                            <label for="edqtdformula">Quantidade:</label>
                            <money type="text" class="form-control form-control-sm" id="edqtdformula" v-model="vqtdformula" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
                        </div>                                                
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdconfirmaimportaformula()"><i class="fa fa-check"></i> Importar</button>
                    <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
                </div>
                
            </div>
            </div>
        </div>
        <!-- Modal do menu da ordem de producao -->
		<div class="modal fade" id="mdmenuordemproducao">
			<div class="modal-dialog modal-sm modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-body">
					<div class="row">
						<div class="col-md-12">
							<ul class="list-group" style="cursor: pointer;">
								<li class="list-group-item font-weight-bold text-center active"     data-dismiss="modal" style="font-size: 18px;">{{ mtdformatarzeros(opmenu.id, 8) }}</li>
								<li class="list-group-item list-group-item-action font-weight-bold" data-dismiss="modal" style="color: #6c757d;" @click.prevent="mtdalterar(opmenu)"><i class="fa fa-edit"></i> ALTERAR</li>
								<li class="list-group-item list-group-item-action font-weight-bold" data-dismiss="modal" style="color: #6c757d;" @click.prevent="mtdexcluir(opmenu)"><i class="fa fa-trash"></i> EXCLUIR</li>                                
								<li class="list-group-item list-group-item-action font-weight-bold" data-dismiss="modal" style="color: #6c757d;" @click.prevent="mtdimprimirproducao(opmenu.id)"><i class="fa fa-print"></i> IMPRIMIR</li>                                
								<li class="list-group-item list-group-item-action font-weight-bold" data-dismiss="modal" style="color: #6c757d;" @click.prevent="mtdefetivacao(opmenu.id)"><i class="fa fa-check"></i> EFETIVAR</li>                                
								<li class="list-group-item list-group-item-action font-weight-bold" data-dismiss="modal" style="color: #6c757d;" @click.prevent="mtddetalhes(opmenu.id)"><i class="fa fa-info"></i> DETALHES</li>                                								
							</ul>
						</div>
					</div>
				</div>
				<div class="modal-footer" style="padding: 5px;">
					<div class="container-fluid">
						<div class="row">
							<div class="col-md-12 text-center">
								<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 150px;"><i class="fa fa-close"></i> Cancelar</button>
							</div>
						</div>					
					</div>
				</div>				        
			</div>
			</div>
		</div>                
    </div>    
</template>
<script>
    import BreadCrumb from '../components/cmpbreadcrumb.vue'
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import vPagination from 'vue-plain-pagination'
    import ConsultarProdutos from '../components/cmpconsultarprodutos.vue'
    import util from '../utilitarios/util.js'

    export default {        
        name: 'cadordensproducao',
        components:{
            VueBootstrap4Table,
            vPagination,
            'breadcrumb' : BreadCrumb,
            'consultaprodutos'  : ConsultarProdutos
        },
        data: function() {
            return {
                //menu
                opmenu              : [],
                utodasfiliais 		: this.$store.state.usuario.todasfiliais,
                //variáveis do leitor de código de barras

                //variáveis para a consulta de produtos
                vshowprtabela		: false,
                vidtabela           : null,
                tipopropesquisa     : '',             
                
                lstordensproducao  : [],
                pfiltro      : 1,
                pconteudo    : '',
                psituacao    : 2,   
				pfiltroperiodo      : 1,
                pidfilial           : null,
				pdtini       		: util.DataAtual(true),
				pdtfim       		: util.DataAtual(true),				                
                pqtdregistros: 10,
                pqtd_paginas : 1,
                pagina_atual : 1,
                pqtd_total_registros: 0,

                //variáveis do crud
                origempesq          : 1,
                opcrud              :  0,
                vid                 : '',
                vdescricao          : '',
                vidfilial           : null,
                vdtinicio           : util.DataAtual(),
                vdttermino          : util.DataAtual(),
                vtotalcusto         : 0,
                vcoddigprod         : '',
                vidprodutoprod  	: '',
                vdescricaoprodutoprod: '',                
                vundprodutoprod		: '',
                vqtditemprod        : 1,
                videstoqueprod      : null,
                vfracionadoprod 	: '',                               

                //variaveis da ordem de produção
                lstitens            : [],
                vitem               : 0,
                vcoddig             : '',
                vidproduto			: '',
                vdescricaoproduto 	: '',                
                vundproduto			: '',
                vqtditem            : 1,
                videstoque          : null,
                vfracionado			: '',
                vprcusto            : 0,
                vnomearquivo        : '',

                //variaveis efetivacao
                efetivacao          : false,
                eid                 : '',                
                esituacao           : 0,
                edescricao          : '',
                ecoddig             : '',
                edescproduto        : '',
                eqtditem            : 1,
                eqtditemprevista    : 1,
                eidestoque          : 0,
                edescestoque        : '',
                etotalcusto         : 0,
                elstitens           : [],
                elstitensperdas     : [],
                //perdas
                vitemperda          : 0,
                vidprodutoperda     : null,
                vqtditemperda       : 1,
                videstoqueperda     : null,
                vproselecionadoperda: [],
                
                //carregar fórmula
                vidformulaimportar  : null,
                vqtdformula         : 1,
                videstoqueformula   : null,
                lstitensformula     : [],


                //variável para habilitação dos campos
                ativadesativa       : true,
				money				: {
                    decimal         : ',',
                    thousands       : '.',
                    prefix          : '',//aqui colocar o cifrão se for necessário
                    precision       : 2,
                    masked          : false
                },                
                options: {
                    format          : 'DD/MM/YYYY',
                    useCurrent      : false,
                    locale          : 'pt-BR'
                },
                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
                },
                itensbc : {
                    item1 : {
                        titulo : 'ORDEM DE PRODUÇÃO',
                        ativo  : false
                    },
                    item2 : {
                        titulo : '',
                        ativo  : false
                    }
                },
                columns: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes-conf",
                        sort: false
                    },
                    {
                        label: "Código",
                        name: "id",
                        sort: true,
                        slot_name: "id_f",
                        row_classes: "def-col-cod"
                    },
                    {
                        label: "Filial",
                        name: "fantasiafil",
                        initial_sort : true,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Estoque",
                        name: "descestoque",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        row_classes: "def-col-descestoque"
                    },                    
                    {
                        label: "Estoque",
                        name: "descestoque",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        row_classes: "def-col-descestoque"
                    },                    
                    {
                        label: "Início",
                        name: "dtinicio",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        row_classes: "def-col-dtinicio"
                    },{
                        label: "Término",
                        name: "dttermino",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        row_classes: "def-col-dtinicio"
                    },
                    {
                        label: "Total Custo",
                        name: "totalcusto",
                        sort: true,
                        slot_name: "slot_totalcusto",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",
                        row_classes: "def-col-totalcusto"
                    },
                    {
                        label: "Situação",
                        name: "situacao",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-left",
                        slot_name: "slot_situacao",
                        row_classes: "def-col-situacao"
                    },
                    {
                        label: "Efetivação",
                        name: "dtefetivacao",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        row_classes: "def-col-finalizacao"
                    },
                    {
                        label: "Usu. efetiva",
                        name: "nomeusu",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        row_classes: "def-col-nomeusu"
                    }
                ],
                columnsitens: [
                    {
                        label: '',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes-item",
                        sort: false
                    },
                    {
                        label: "Item",
                        name: "item",
                        sort: true,
                        slot_name: "slot_item",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Código",
                        name: "coddig",
                        sort: true,
                        slot_name: "slot_codigo",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Descrição",
                        name: "descproduto",
                        sort: true,
                        slot_name: "slot_descpro",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                    },
                    {
                        label: "Pr. Custo",
                        name: "prcusto",
                        sort: true,
                        slot_name: "slot_prcusto",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-center"
                    },
                    {
                        label: "Qtd",
                        name: "qtditem",
                        sort: true,
                        slot_name: "slot_qtditem",
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-left",
                        row_classes: "def-col-qtd-item",
                    },
                    {
                        label: "Und",
                        name: "unditem",
                        sort: true,
                        slot_name: "slot_unditem",
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-left",
                        row_classes: "def-col-und-item",
                    },
                    {
                        label: "Total Custo",
                        name: "totalcusto",
                        sort: true,
                        slot_name: "slot_totalcusto",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-center"
                    },
                    {
                        label: "Estoque",
                        name: "descestoque",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                    }
                ],                             
                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    //checkbox_rows: true,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                configitens: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    checkbox_rows: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },                 
                classes: {
                    table: "table-bordered table-striped table-sm"
                }
            }
        },
        methods:{
            mtdmostrarmenu(op){				
                this.opmenu = op;
				$('#mdmenuordemproducao').modal('show');
            },   
			mtdformatarzeros(str, length){
				return util.formatarzeros(str, length);
            },                     
            mtdformatavalordecimal(valor, digitos){
                return util.formatavalordecimais(valor, digitos);
            },
			mtdformatadatagravar(dtformatar){
				let strret = dtformatar.replace(/\D/g, "");
				return strret.substring(0,2)+'/'+strret.substring(2,4)+'/'+strret.substring(4);
			},            
            mtddefinial(){
                let vself = this;

				let sqliniusuario = parseInt(vself.utodasfiliais) === 0 ? 'select f.codfil, f.fantasia from tbfiliaisusuario fu left join tbfiliais f on f.codfil=fu.idfilial ' : 'select codfil, fantasia from tbfiliais ';
				let sqlfimusuario = parseInt(vself.utodasfiliais) === 0 ? 'where upper(f.fantasia) like upper("%@@%") and fu.idusuario='+vself.$store.state.usuario.id 		 : 'where upper(fantasia) like upper("%@@%")';

				$("#cbfilialpesq").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.pidfilial = $("#cbfilialpesq").val();
				});

				$("#cbfilial").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidfilial = $("#cbfilial").val();
                    let loader      = vself.$loading.show();
                    let filtro      = ' and f.codfil='+vself.vidfilial;
                    let parametros  = [
                        {parametro: 'op',           valor : 'listagem'},
                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'diretoriocertificados', valor : vself.$store.state.configpaths.pathcertificados+vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'filtro',       valor : filtro},
                        {parametro: 'limit',        valor : 1},
                        {parametro: 'offset',       valor : 0},
                    ];
                    let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadfiliais.php');
                    retorno.then(function (response) {
                        loader.hide();
                        if (response.data.length > 0){
                            var defestpro = new Option(response.data[0].descestoque, response.data[0].idestoque, true, true);
                            $('#cbestoqueprod').append(defestpro).trigger('change');

                            var defest = new Option(response.data[0].descestoque, response.data[0].idestoque, true, true);
                            $('#cbestoque').append(defest).trigger('change');	                                            	                
                        }
                    }).catch(function (response) {
                        loader.hide();
                    });                    
				});                      
				$("#cbestoqueprod").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbestoques',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.videstoqueprod = $("#cbestoqueprod").val();
				});                
				$("#cbestoque").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbestoques',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.videstoque = $("#cbestoque").val();
				});
                $('#btselecionararquivo').change(function() {
                    vself.mtdrotinaferencia();
                });                 
            
				$("#cbprodutoperda").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'vtprodutosconsumoambos',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 1,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidprodutoperda = $("#cbprodutoperda").val();
                    let loader      = vself.$loading.show();
                    let filtro      = ' and p.id='+vself.vidprodutoperda;
                    let parametros  = [
                        {parametro: 'op',               valor : 'listagem'},
                        {parametro: 'idclientesac',     valor : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'filtro',           valor : filtro},
                        {parametro: 'limit',            valor : 1},
                        {parametro: 'offset',           valor : 0},
                    ];
                    let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
                    retorno.then(function (response) {
                        loader.hide();
                        if (response.data.length > 0){
                            vself.vproselecionadoperda = response.data[0];
                        }else{
                            vself.vproselecionadoperda = [];
                        }
                    }).catch(function (response) {
                        loader.hide();
                    });                                        
				});                             
				$("#cbestoqueperda").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbestoques',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.videstoqueperda = $("#cbestoqueperda").val();
				});            
				$("#cbformula").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbformulas',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidformulaimportar = $("#cbformula").val();
                    let loader      = vself.$loading.show();
                    let filtro      = ' and id='+vself.vidformulaimportar;
                    let parametros  = [
                        {parametro: 'op',           valor : 'listagem'},
                        {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'filtro',       valor : filtro},
                        {parametro: 'limit',        valor : 1},
                        {parametro: 'offset',       valor : 0},
                    ];
                    let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadformulas.php');
                    retorno.then(function (response) {
                        loader.hide();
                        vself.lstitensformula = response.data[0].itens;
                    }).catch(function (response) {
                        loader.hide();
                    });                    
				});            
				$("#cbestoqueformula").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbestoques',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.videstoqueformula = $("#cbestoqueformula").val();
				});
            },
            mtdfiltropesquisa(){
                let rfiltro = '';
                if (parseInt(this.pfiltro) === 0){
                    rfiltro = this.pconteudo === '' ? '' : ' and o.id='+this.pconteudo;
                }else{
                    rfiltro = this.pconteudo === '' ? '' : ' and upper(o.descricao) like upper("'+this.pconteudo+'%")';
                }
				if (this.pidfilial !== null){
					rfiltro = rfiltro + ' and o.idfilial='+this.pidfilial;
				}
				if(parseInt(this.pfiltroperiodo) === 1){
					rfiltro = rfiltro + ' and o.dtinicio between "' + util.InverterData(this.pdtini) + '" and "' + util.InverterData(this.pdtfim) + '"';                
                }

                if (parseInt(this.psituacao) < 2){
                    rfiltro = rfiltro + ' and o.situacao='+this.psituacao;
                }
                return rfiltro;
            },
            mtdexecutapesquisa(){
                var vself           = this;
                let filtro          = vself.mtdfiltropesquisa();
                this.pagina_atual   = 1;
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'qtdregistros'},
                    {parametro: 'filtro',       valor  : filtro}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadordensproducao.php');
                retorno.then(function (response) {
                    vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
                    let qtdpg                  = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                    vself.pqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
                    vself.mtdcarregaordensproducao(1);
                }).catch(function (response) {
                    alert('Erro ao consultar registros');
                });
            },
            mtdcarregaordensproducao(ipagina){
                var vself       = this;
                let loader      = this.$loading.show();
                vself.$refs.reflstordensproducao.selected_items = [];//limpa os ítens selecionados na table 
                let filtro      = vself.mtdfiltropesquisa();
                let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : vself.pqtdregistros},
                    {parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)}
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadordensproducao.php');
                retorno.then(function (response) {
                    vself.lstordensproducao = response.data;
                    loader.hide();
                }).catch(function (response) {
                    vself.lstordensproducao = [];
                    loader.hide();
                });
            },
            resetarDados() {
                util.toTop();

                this.vid                = '';
                this.vdescricao         = '';                
                this.vidfilial          = this.$store.state.filialpadrao.codfil;

                this.vdtinicio		    = util.DataAtual();
                this.vdttermino		    = util.DataAtual();
                this.vcoddigprod        = '';
                this.vidprodutoprod  	= '';
                this.vdescricaoprodutoprod= '';
                this.vundprodutoprod	= '';
                this.vqtditemprod       = 1;
                this.videstoqueprod     = null;
                this.vfracionadoprod 	= '';                
                this.vtotalcusto        = 0;

                this.lstitens           = [];
                this.vitem              = 0;
                this.vidproduto			= '';
                this.vcoddig            = '';
                this.vdescricaoproduto 	= '';
                this.vundproduto		= '';
                this.vprcusto           = 0;
                this.vqtditem           = 1;
                this.videstoque         = null;
                this.vfracionado		= ''; 
                
                $("#cbestoque").val(null).trigger('change');

				if (parseInt(this.opcrud) === 1){
					var deffilial  			= new Option(this.$store.state.filialpadrao.fantasia, this.vidfilial, true, true);
					$('#cbfilial').append(deffilial).trigger('change');	
                }

            },
            mtddefault(){
                $('#pnlista').hide();
                this.resetarDados();
                $('#pncadastro').fadeIn(700);
                setTimeout(() => {
                    if (parseInt(this.opcrud) < 3) {
                        $('#eddescricao').focus();
                    } else {
                        $('#btgravar').focus();
                    }                    
                }, 1000);
            },
            mtdpreparacrud(op) {
                let vself    = this;
                vself.opcrud = op;
                $('.nav-tabs a[href="#dvperfil"]').tab('show');
                vself.mtddefault();
            },
            mtdnovo(){
                if (!util.opcaousuario('010Z.040Z.010Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'INCLUSÃO DE ORDEM DE PRODUÇÃO';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(1);
                }
            },
            mtdcancelaredicao(){
                this.itensbc.item1.ativo = false;
                this.itensbc.item2.ativo = false;
                $('#pncadastro').hide();
                $('#pnlista').fadeIn(700);
                $('#edconteudopesq').focus();
                setTimeout(function(){
                    util.toTop();
                }, 200);
            },
            mtdlimpar_listagem() {
                this.lstordensproducao = [];
                this.$refs.reflstordensproducao.selected_items = [];//limpa os ítens selecionados na table                 
                this.pagina_atual = 1;
                this.filtro = '';
                this.pqtd_total_registros = 0;
                this.pqtd_paginas = 0;
            },
            mtdgravar(){
                let vself = this;
                if (parseInt(vself.opcrud) < 3) {
                    if (parseInt(vself.vtodasfiliais) === 0) {
                    }
                }
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma ' + vself.itensbc.item2.titulo + '?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                vself.mtdregistro();
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btgravar').focus();
                            }
                        }
                    }
                });
            },
            mtdlocalizaregistro(id){
                var vself       = this;
                let loader      = vself.$loading.show();
                let filtro      = ' and o.id='+id;
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadordensproducao.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.mtdigualarcampos(response.data[0]);
                    if (parseInt(vself.opcrud) < 3){
                        $('#eddescricao').focus();
                    }else{
                        $('#btgravar').focus();
                    }
                }).catch(function (response) {
                    loader.hide();
                });
            },
            mtdalterar(item){
                if (!util.opcaousuario('010Z.040Z.020Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    if (parseInt(item.situacao) === 1 ){
                        this.$toastr.i('Ordem de produção já finalizada, impossível realizar esta operação!', 'Informação!');
                        return;
                    }                         
                    this.itensbc.item2.titulo = 'ALTERAÇÃO DE ORDEM DE PRODUÇÃO';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(2);
                    this.mtdlocalizaregistro(item.id);
                }
            },
            mtdexcluir(item){
                if (!util.opcaousuario('010Z.040Z.030Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    if (parseInt(item.situacao) === 1 ){
                        this.$toastr.i('Ordem de produção já finalizada, impossível realizar esta operação!', 'Informação!');
                        return;
                    }                           
                    this.itensbc.item2.titulo = 'EXCLUSÃO DE ORDEM DE PRODUÇÃO';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = true;
                    this.mtdpreparacrud(3);
                    this.mtdlocalizaregistro(item.id);
                }
            },
            mtdigualarcampos(registro){
                this.vid                    = registro.id;
                this.vdescricao             = registro.descricao;
                this.vidprodutoprod         = registro.idproduto;
                this.vdtinicio		        = registro.dtinicio;
                this.vdttermino		        = registro.dttermino;
                this.vcoddigprod            = registro.coddig;
                this.vdescricaoprodutoprod  = registro.descproduto;
                this.vfracionadoprod 	    = registro.fracionado;
                this.lstitens               = registro.itens;
                this.vqtditemprod           = registro.qtditem;
                this.vundprodutoprod	    = registro.und;
                this.vitem                  = this.lstitens[this.lstitens.length - 1].item;
                this.vtotalcusto            = parseFloat(registro.totalcusto);
                this.vidfilial              = registro.idfilial;
                this.videstoqueprod         = registro.idestoque;

                var deffilial  = new Option(registro.fantasiafil, this.vidfilial, true, true);
				$('#cbfilial').append(deffilial).trigger('change');

                var defestoque = new Option(registro.descestoque, this.videstoqueprod, true, true);
                $('#cbestoqueprod').append(defestoque).trigger('change');
            },
            mtdregistro(){
                let vself  = this;
                if (parseInt(vself.vfracionadoprod) === 0){
                    if (!Number.isInteger(vself.vqtdformula)){
						vself.$toastr.w('Quantidade não pode ser FRACIONADA!', 'Atenção!');
						$('#edqtditemprod').focus();
                        return;
                    }
                }                
                let loader = vself.$loading.show();
                let registrocrud = {
                    'id'                : this.vid,
                    'descricao'         : this.vdescricao,
                    'idfilial'          : this.vidfilial,
                    'dtinicio'			: this.mtdformatadatagravar(this.vdtinicio),
                    'dttermino'			: this.mtdformatadatagravar(this.vdttermino),                    
                    'idestoque'         : this.videstoqueprod,
                    'idproduto'         : this.vidprodutoprod,
                    'coddig'            : this.vcoddigprod,
                    'qtditem'           : this.vqtditemprod,
                    'totalcusto'        : this.vtotalcusto,
                    'itens'             : this.lstitens
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'rotinacrud'},
                    {parametro: 'opcrud',       valor : vself.opcrud},
                    {parametro: 'registro',     valor : JSON.stringify(registrocrud)},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : parseInt(this.opcrud) === 1 ? '010Z.040Z.010Z' : parseInt(this.opcrud) === 2 ? '010Z.040Z.020Z' : '010Z.040Z.030Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadordensproducao.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                        vself.pfiltro       = 0;
                        vself.pconteudo     = parseInt(vself.opcrud) === 1 ? response.data : vself.vid;
                        vself.pqtd_paginas  = 1;
                        vself.mtdcancelaredicao();
                        vself.mtdcarregaordensproducao(1);
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },
            mtdlocalizarproduto(coddig, origem){
                var vself   = this;
				if (coddig !== '' && coddig !== null){					
					let loader      = vself.$loading.show();
					let parametros  = [
						{parametro: 'op',               valor : 'listagem'},
						{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
						{parametro: 'filtro',           valor : ''},
						{parametro: 'coddig',           valor : coddig},
						{parametro: 'limit',            valor : 1},
						{parametro: 'offset',           valor : 0},
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
					retorno.then(function (response) {
						loader.hide();						
						if (response.data.length > 0){
                            let produto = response.data[0];
                            if (origem === 2){
                                if (parseInt(produto.tipo) !== 2){
                                    if (parseInt(produto.tipo) === 0){
                                        vself.$toastr.w('Produto comercializado não pode ser usado como insumo de produção!', 'Atenção!');
                                        $('#edidproduto').focus();
                                        return;
                                    }
                                }                                
                                vself.vidproduto			= produto.id;
                                vself.vdescricaoproduto 	= produto.descricao;
                                vself.vundproduto			= produto.und;
                                vself.vfracionado			= produto.fracionado;
                                vself.vprcusto              = produto.prcusto;

                                if (vself.lancarauto){
                                    let indiceitem = util.getArrayIndexForKey(vself.lstitens, 'idproduto', vself.vidproduto);

                                    vself.vitem++;                         

                                    let itemtmp = {
                                        idproduto		    : vself.vidproduto,
                                        descproduto		    : vself.vdescricaoproduto,
                                        coddig			    : vself.vcoddig,
                                        item			    : vself.vitem,
                                        qtditem			    : vself.vqtditem,
                                        unditem			    : vself.vundproduto,
                                        prcusto             : vself.vprcusto
                                    };

                                    if (parseInt(vself.vfracionado) === 0){
                                        if (!Number.isInteger(vself.vqtditem)){
                                            vself.$toastr.w('Quantidade não pode ser FRACIONADA!', 'Atenção!');
                                            $('#edqtditem').focus();
                                            return;
                                        }
                                    }                                                

                                    if (indiceitem !== -1){
                                        itemtmp.item = indiceitem;                                   
                                        vself.mtdalterarqtd(itemtmp, true, itemtmp.qtditem);								
                                    }else{
                                        vself.mtdlancaitem(itemtmp);
                                    }
                                    setTimeout(() => {
                                        vself.vidproduto          = '';
                                        vself.vdescricaoproduto   = '';
                                        vself.vcoddig             = '';
                                        vself.vqtditem            = 1;                                    
                                        $('#edidproduto').focus();                                                                                                                      
                                    }, 200);                                 
                                }else{
                                    vself.$nextTick(function () {
                                        $('#edqtditem').focus();
                                    });
                                }                                
                            }else{
                                if (parseInt(produto.tipo) !== 2){
                                    if (parseInt(produto.tipo) === 1){
                                        vself.$toastr.w('Produto de consumo/insumo não pode ser usado como item a ser produzido!', 'Atenção!');
                                        $('#edidproduto').focus();
                                        return;
                                    }                                 
                                }
                                vself.vidprodutoprod		= produto.id;
                                vself.vdescricaoprodutoprod	= produto.descricao;
                                vself.vundprodutoprod		= produto.und;
                                vself.vfracionadoprod		= produto.fracionado;
                                vself.vqtditemprod          = 1;
                                vself.$nextTick(function () {
                                    $('#edqtditemprod').focus();
                                });                                 
                            }                         
						}else{
                            vself.$toastr.w('Código informado não cadastrado no sistema!', 'Atenção!');
                            if (origem === 2){                                 
                                vself.vidproduto			= '';
                                vself.vdescricaoproduto 	= '';
                                vself.vundproduto			= '';
                                vself.vfracionado			= '';
                                vself.vprcusto              = 0;
                                $('#edidproduto').focus();
                            }else{
                                vself.vidprodutoprod		= '';
                                vself.vdescricaoprodutoprod	= '';
                                vself.vundprodutoprod		= '';
                                vself.vfracionadoprod		= '';
                                $('#edidprodutoprod').focus();
                            }
						}
					}).catch(function (response) {
						loader.hide();
					});
				}else{
                    if(origem === 2){ 
                        vself.vidproduto			= '';
                        vself.vdescricaoproduto 	= '';
                        vself.vundproduto			= '';
                        vself.vfracionado			= '';
                        vself.vprcusto              = 0;
                    }else{
                        vself.vidprodutoprod		= '';
                        vself.vdescricaoprodutoprod	= '';
                        vself.vundprodutoprod		= '';
                        vself.vfracionadoprod		= '';                        
                    }
				}
            },        
            mtdconsultarproduto(origem){
                this.origempesq = origem;
                if (parseInt(origem) === 1){
                    this.tipopropesquisa = '0, 2';
                }else{
                    this.tipopropesquisa = '1, 2';
                }
				if (parseInt(this.opcrud) < 3){
					let payload = {
						abrirtela    : true			
					};
					this.$store.commit('CONSULTA_PRODUTO_CHANGE',payload);
					let payloadx = {
						idproduto    : null			
					};
					this.$store.commit('PRODUTO_RETORNO_CHANGE',payloadx);                
				}
			},
            mtdincluiritem(){
                let vself = this;
                if (vself.vcoddig === ''){                    
                    vself.$toastr.w('Código do produto deve ser informado!', 'Informação!');
                    $('#edidproduto').focus();
                    return;
                }
                if (parseFloat(vself.vqtditem) <= 0){                    
                    vself.$toastr.w('Quantidade inválida!', 'Informação!');
                    $('#edqtditem').focus();
                    return;
                }  
                if (vself.videstoque === null){                    
                    vself.$toastr.w('Estoque deve ser informado!', 'Informação!');
                    $('#cbestoque').select2('open');
                    return;
                }                              
                if (parseInt(vself.vfracionado) === 0){
                    if (!Number.isInteger(vself.vqtditem)){
						vself.$toastr.w('Quantidade não pode ser FRACIONADA!', 'Atenção!');
						$('#edqtditem').focus();
                        return;
                    }
                }

                let indiceitem = util.getArrayIndexForKey(vself.lstitens, 'idproduto', vself.vidproduto);
                vself.vitem++;

                let itemtmp = {
                    idproduto		    : vself.vidproduto,
                    descproduto		    : vself.vdescricaoproduto,
                    coddig			    : vself.vcoddig,
                    item			    : vself.vitem,
                    qtditem			    : vself.vqtditem,
                    unditem			    : vself.vundproduto,
                    prcusto             : vself.vprcusto,
                    idestoque           : vself.videstoque,
                    descestoque		    : $('#cbestoque').select2('data')[0]['text'],
                    totalcusto          : util.arredondaValores( parseFloat(vself.vprcusto) * parseFloat(vself.vqtditem), 3, 'round')
                };                
                if (indiceitem !== -1){
                    $.confirm({
                        title: 'Confirmação!',
                        content: 'Produto já lançado na produção. Deseja adicionar a quantidade?',
                        icon: 'fa fa-question-circle',
                        escapeKey: true,
                        backgroundDismiss: false,
                        escapeKey: 'nao',
                        type: 'dark',
                        typeAnimated: true,
                        buttons: {
                            sim: {
                                text: '<u>S</u>im',
                                keys: ['s', 'S'],
                                btnClass: 'btn-blue',
                                action: function () {
                                    $('.btn-blue').prop('disabled', true); 
                                    itemtmp.item = indiceitem;                                   
                                    vself.mtdalterarqtd(itemtmp, true, itemtmp.qtditem);

                                    vself.vidproduto          = '';
                                    vself.vdescricaoproduto   = '';
                                    vself.vcoddig             = '';
                                    vself.vqtditem            = 1;
                                    vself.vprcusto            = 0;
                                    setTimeout(() => {
                                        $('#edidproduto').focus();                                                                                                                      
                                    }, 500);                                  
                                },
                            },
                            nao: {
                                text: '<u>N</u>ão',
                                keys: ['n', 'N'],
                                action: function () {                                
                                    vself.vidproduto          = '';
                                    vself.vdescricaoproduto   = '';
                                    vself.vcoddig             = '';
                                    vself.vqtditem            = 1; 
                                    vself.vprcusto            = 0;                                            
                                    setTimeout(() => {
                                        $('#edidproduto').focus();                                                                                                                      
                                    }, 500);
                                    
                                }
                            }
                        }
                    });                    
                }else{
                    vself.mtdlancaitem(itemtmp);
                }                                
            },            
            mtdlancaitem(itemtmp){
                let vself = this;
                vself.vtotalcusto = parseFloat(vself.vtotalcusto) + parseFloat(itemtmp.totalcusto);
                vself.lstitens.push(itemtmp);    
                vself.vidproduto          = '';
                vself.vdescricaoproduto   = '';
                vself.vundproduto         = '';  
                vself.vcoddig             = '';
                vself.vqtditem            = 1;
                vself.vprcusto            = 0;
                $('#edidproduto').focus();                
            },
            mtdexcluiritem(item){
                let indiceitem 		= util.getArrayIndexForKey(this.lstitens, 'item', item.item);
                this.vtotalcusto    = parseFloat(this.vtotalcusto) - parseFloat(item.totalcusto);
                this.lstitens.splice(indiceitem, 1);                
            },
            mtdalterarqtd(item, aumentar, qtd){
                if (parseInt(this.opcrud) < 3){
                    let indiceitem 		= util.getArrayIndexForKey(this.lstitens, 'idproduto', item.idproduto);                
                    if (aumentar) {
                        this.lstitens[indiceitem].qtditem   += parseFloat(qtd); 
                        this.lstitens[indiceitem].totalcusto = util.arredondaValores(parseFloat(this.lstitens[indiceitem].qtditem) * parseFloat(this.lstitens[indiceitem].prcusto), 3, 'round'); 
                        this.vtotalcusto = parseFloat(this.vtotalcusto) + parseFloat(parseFloat(qtd) * parseFloat(this.lstitens[indiceitem].prcusto));
                    }else{
                        if (parseFloat(this.lstitens[indiceitem].qtditem) > 1){
                            this.lstitens[indiceitem].qtditem   -= parseFloat(qtd);
                            this.lstitens[indiceitem].totalcusto = util.arredondaValores(parseFloat(this.lstitens[indiceitem].qtditem) * parseFloat(this.lstitens[indiceitem].prcusto), 3, 'round'); 
                            this.vtotalcusto = parseFloat(this.vtotalcusto) - parseFloat(parseFloat(qtd) * parseFloat(this.lstitens[indiceitem].prcusto));
                        }else{
                            return;
                        }
                    }    
                }
            },
            mtdincluiritemperda(){                
                let vself     = this;
                if (vself.vidprodutoperda === null){
                    vself.$toastr.w('Produto deve ser informado!', 'Atenção!');
                    $('#cbprodutoperda').select2('open');                    
                    return;
                }                 
                if (vself.videstoqueperda === null){
                    vself.$toastr.w('Estoque deve ser informado!', 'Atenção!');
                    $('#cbestoqueperda').select2('open');                    
                    return;
                }                
                let encontrou = false;
                for (let item of vself.elstitens) {
                   if (parseInt(item.idproduto) === parseInt(vself.vproselecionadoperda.id)){
                        encontrou = true;
                        break;
                   } 
                }
                if (!encontrou){
                    vself.$toastr.w('Produto não encontrado nos insumos!', 'Atenção!');
                    $('#cbprodutoperda').select2('open');
                }else{
                    let indiceitem = util.getArrayIndexForKey(vself.elstitensperdas, 'idproduto', vself.vproselecionadoperda.id);                    
                    if (indiceitem === -1){
                        vself.vitemperda++;
                        let itemtmp = {
                            idproduto		    : vself.vproselecionadoperda.id,
                            descproduto		    : vself.vproselecionadoperda.descricao,
                            coddig			    : vself.vproselecionadoperda.id,
                            item			    : vself.vitemperda,
                            qtditem			    : vself.vqtditemperda,
                            unditem			    : vself.vproselecionadoperda.und,
                            prcusto             : vself.vproselecionadoperda.prcusto,
                            idestoque           : vself.videstoqueperda,
                            descestoque		    : $('#cbestoqueperda').select2('data')[0]['text'],
                            totalcusto          : util.arredondaValores( parseFloat(vself.vproselecionadoperda.prcusto) * parseFloat(vself.vqtditemperda), 3, 'round')
                        };
                        vself.etotalcusto = parseFloat(vself.etotalcusto) + parseFloat(itemtmp.totalcusto);
                        vself.elstitensperdas.push(itemtmp);
                        vself.vidprodutoperda       = null;
                        $("#cbprodutoperda").val(null).trigger('change');
                        vself.vproselecionadoperda  = [];
                        vself.vqtditemperda         = 1;
                        $("#cbprodutoperda").select2('open');                        
                    }else{
                        vself.$toastr.w('Produto já lançado como perda!', 'Atenção!');
                        $("#cbprodutoperda").select2('open');
                    }
                }
            },
            mtdexcluiritemperda(item){
                let indiceitem 		= util.getArrayIndexForKey(this.elstitensperdas, 'item', item.item);
                this.etotalcusto    = parseFloat(this.etotalcusto) - parseFloat(item.totalcusto);
                this.elstitensperdas.splice(indiceitem, 1);                
            },
            mtdefetivacao(idordemproducao){                
                let vself               = this; 
                $('.nav-tabs a[href="#dvinsumos"]').tab('show');
                vself.elstitensperdas   = [];               
                if (!util.opcaousuario('010Z.040Z.040Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else{
                    vself.efetivacao        = true;
                    let loader = vself.$loading.show();
                    let filtro      = ' and o.id='+idordemproducao;
                    let parametros  = [
                        {parametro: 'op',           valor : 'listagem'},
                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'filtro',       valor : filtro},
                        {parametro: 'limit',        valor : 1},
                        {parametro: 'offset',       valor : 0},
                    ];
                    let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadordensproducao.php');
                    retorno.then(function (response) {
                        loader.hide();
                        if (parseInt(response.data[0].situacao) === 1){
                            vself.$toastr.w('Ordem de produção já efetivada!', 'Atenção!');
                        }else{
                            vself.eid               = response.data[0].id;
                            vself.esituacao         = response.data[0].situacao;
                            vself.edescricao        = response.data[0].descricao;
                            vself.ecoddig           = response.data[0].coddig;
                            vself.edescproduto      = response.data[0].descproduto;
                            vself.eqtditemprevista  = response.data[0].qtditem;
                            vself.eqtditem          = response.data[0].qtditem;                            
                            vself.eidestoque        = response.data[0].idestoque;
                            vself.edescestoque      = response.data[0].descestoque;                            
                            vself.etotalcusto       = response.data[0].totalcusto;
                            vself.elstitens         = response.data[0].itens;                            
                            $('#mdlefetivacao').modal('show');
                        }
                    }).catch(function (response) {
                        loader.hide();
                        vself.$toastr.e('Erro ao carregar dados da ordem de produção. Descrição do erro: '+response.message, 'Erro!');
                    });                                
                }                            
            },
            mtdconfirmaefetivacao(){
                let vself = this;
                $('.nav-tabs a[href="#dvinsumos"]').tab('show');
                $.confirm({
                    title: 'Confirmação!',
                    content: 'O processo de ajuste do estoque pode demorar alguns minutos. Deseja mesmo continuar com a Efetivação?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);                                
                                let loader = vself.$loading.show();
                                let parametros          = [
                                    {parametro: 'idclientesac',     valor : vself.$store.state.filialpadrao.idcliente},
                                    {parametro: 'op',               valor : 'efetivar'},
                                    {parametro: 'idordemproducao',  valor : vself.eid},
                                    {parametro: 'qtdproduzida',     valor : vself.eqtditem},
                                    {parametro: 'totalcustofinal',  valor : vself.etotalcusto},
                                    {parametro: 'itensperda',       valor : JSON.stringify(vself.elstitensperdas)},
                                    {parametro: 'idfilial',         valor : vself.$store.state.filialpadrao.codfil},                                    
                                    {parametro: 'idusuario',        valor : vself.$store.state.usuario.id}
                                ];
                                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadordensproducao.php');
                                retorno.then(function (response) {
                                    loader.hide();
                                    if ($.isNumeric(response.data)){                                            
                                        vself.$toastr.s("Ordem de produção efetivada com sucesso!", 'Atenção!');
                                        $('#mdlefetivacao').modal('hide');
                                        vself.efetivacao    = false;
                                        vself.pfiltro       = 0;
                                        vself.pconteudo     = vself.eid;
                                        vself.pqtd_paginas  = 1;
                                        vself.mtdcancelaredicao();
                                        vself.mtdcarregaordensproducao(1);
                                    }else{                                            
                                        let tpret = response.data.substring(0,1);
                                        switch (tpret) {
                                            case 'I':
                                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                                break;
                                            case 'E': default:
                                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                                break;
                                        }
                                    }
                                }).catch(function (response) {                                        
                                    loader.hide();
                                    vself.efetivacao = false;
                                    vself.$toastr.e('Erro ao carregar dados da ordem de produção. Descrição do erro: '+response.message, 'Erro!');
                                    $('#mdlefetivacao').modal('hide');
                                });                                                                
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                            }
                        }
                    }
                });              
            },
            mtddetalhes(idordemproducao){
                let vself               = this; 
                vself.elstitensperdas   = [];               
                $('.nav-tabs a[href="#dvinsumos"]').tab('show');
                vself.efetivacao        = false;
                let loader = vself.$loading.show();
                let filtro      = ' and o.id='+idordemproducao;
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadordensproducao.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.eid               = response.data[0].id;
                    vself.esituacao         = response.data[0].situacao;
                    vself.edescricao        = response.data[0].descricao;
                    vself.ecoddig           = response.data[0].coddig;
                    vself.edescproduto      = response.data[0].descproduto;
                    vself.eqtditemprevista  = response.data[0].qtditem;                            
                    vself.eqtditem          = response.data[0].qtdproduzida;                            
                    vself.eidestoque        = response.data[0].idestoque;
                    vself.edescestoque      = response.data[0].descestoque;                            
                    vself.etotalcusto       = response.data[0].totalcusto;
                    vself.elstitens         = response.data[0].itens;                            
                    vself.elstitensperdas   = response.data[0].itensperda;
                    $('#mdlefetivacao').modal('show');
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao carregar dados da ordem de produção. Descrição do erro: '+response.message, 'Erro!');
                });                                  
            },
			mtdimprimirproducao(idordemproducao){				
				window.open(this.$store.state.configpaths.pathcontrole+'rtimprimirordemproducao.php?idclientesac='+
							this.$store.state.filialpadrao.idcliente+
							'&idordemproducao='+idordemproducao+'&idu='+
							this.$store.state.usuario.id, '_blank');				
			},
            mtdobterformula(){
                if (this.vidprodutoprod === ''){
                    this.$toastr.w('Informe o produto a ser produzido!', 'Atenção!');
                    $('#edidprodutoprod').focus();                    
                    return;
                }                
                //carregar fórmula
                this.vidformulaimportar  = null;

                this.videstoquefomula   = this.$store.state.filialpadrao.idestoque;                
                var defest  			= new Option(this.$store.state.filialpadrao.descestoque, this.vidfilial, true, true);
				$('#cbestoqueformula').append(defest).trigger('change');	            			

                $("#cbformula").val(null).trigger('change');
                this.vqtdformula        = 1;                
                $('#mdformula').modal('show');
                setTimeout(() => {
                   $('#cbformula').select2('open'); 
                }, 300);
            },
            mtdconfirmaimportaformula(){
                let vself = this;
                if (parseInt(vself.vfracionadoprod) === 0){
                    if (!Number.isInteger(vself.vqtdformula)){
						vself.$toastr.w('Quantidade não pode ser FRACIONADA!', 'Atenção!');
						$('#edqtdformula').focus();
                        return;
                    }
                }
                if (vself.videstoqueformula === null){
                    vself.$toastr.w('Estoque deve ser informado!', 'Atenção!');
                    $('#cbestoqueformula').select2('open');                    
                    return;
                }                 
                if (vself.vqtdformula < 1){
                    vself.$toastr.w('Quantidade inválida!', 'Atenção!');
                    $('#edqtdformula').focus();                    
                    return;
                }
                if (vself.vidformulaimportar === null){
                    vself.$toastr.w('Fórmula deve ser informada!', 'Atenção!');
                    $('#cbformula').select2('open');                    
                    return;
                }                
                vself.vtotalcusto   = 0;
                vself.lstitens      = [];
                vself.vqtditemprod  = vself.vqtdformula;
                for (let item of vself.lstitensformula) {
                    vself.vtotalcusto   = vself.vtotalcusto + (parseFloat(item.prcusto) * parseFloat(item.qtditem) * parseFloat(vself.vqtdformula));
                    item.totalcusto     = parseFloat(item.prcusto) * parseFloat(item.qtditem) * parseFloat(vself.vqtdformula);
                    item.qtditem        = parseFloat(item.qtditem) * parseFloat(vself.vqtdformula);
                    item.idestoque      = vself.videstoqueformula;
                    item.descestoque    = $('#cbestoqueformula').select2('data')[0]['text'];
                    console.log(item);
                    vself.lstitens.push(item);
                }
                $('#mdformula').modal('hide');
            }    
        },
        mounted: function () {
            if (util.verificasessao(this)) {
                let vself = this;
                let loader = vself.$loading.show();
                let parametros = [
                    {parametro: 'op', valor: 'dadosusuario'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
                    {parametro: 'idusuario', valor: vself.$store.state.usuario.id}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                    if (util.opcaousuario('010Z.040Z', vself.$store.state.perfilusuario)) {
                        $('#pnlista').fadeIn(700);
                        vself.mtddefinial();
                        vself.mtdcarregaordensproducao(vself.pagina_atual);
                    } else {
                        vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                        setTimeout(function(){
                            util.gotoprincipal();
                        },1000);
                    }
                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                });
            }
        },
        computed:{
            validou() {
                return this.vdescricao === '' || this.vidfilial === null || this.vidprodutoprod === null ||
                this.vqtditemprod <= 0 || this.videstoque === null || this.vdtinicio === null || 
                this.vdttermino === null || this.lstitens.length === 0;
            },
            idprodutoretorno(){
                return this.$store.state.produtoretornoconsulta.idproduto;
            },
            idprodutoretornoprod(){
                return this.$store.state.produtoretornoconsulta.idproduto;
            },
			selecionaperiodo(){
				if(parseInt(this.pfiltroperiodo) === 0){
					this.hab_desab_periodo = true;
				}else{
					this.hab_desab_periodo = false;
				}
			}
        },
        watch:{
            pagina_atual(val){
                this.mtdcarregaordensproducao(val);
            },
            idprodutoretorno(val){
                if (val !== null || val !== ''){
                    if (this.origempesq === 2){
                        this.vcoddig = val;
                        this.mtdlocalizarproduto(this.vcoddig, 2);					
                    }else{
                        this.vcoddigprod = val;
                        this.mtdlocalizarproduto(this.vcoddigprod, 1);					
                    }
                }
			}
        }
    }
</script>
<style>
    .def-col-cod{
        width: 80px !important;
    }
    .def-col-opcoes-conf{
        width: 70px !important;
    }
    .def-col-descestoque{
        width: 200px!important;
    }    
    .def-col-qtd-item{
        width: 100px!important;
    }
    .def-col-und-item{
        width: 50px !important;
    }    
    .def-col-dtinicio{
        width: 150px !important;
    }        
    .def-col-situacao{
        width: 100px !important;
    }     
    .def-col-finalizacao{
        width: 150px !important;
    }     
    .badge-item-resultado{
        font-size: 12px !important;
        width : 120px !important;
    }
    .def-col-nomeusu{
        width: 150px !important;
    }
    .def-col-totalcusto{
        width: 120px !important;
    }
   
</style>